let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("covqK"), load("iWT4e"), load("hGXAt"), load("4Kqu1")]).then(() => parcelRequire('i6jK3'));